import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Nav, { scrollToId } from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Offers from "@/components/Offers";
import Team from "@/components/Team";
import { HealthFundsMarquee, PreferredProvider, PartnerCompanies, GovernmentAccepted } from "@/components/HealthFunds";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import BlogTeaser from "@/components/BlogTeaser";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { useSEO } from "@/hooks/useSEO";
import { FEATURES } from "@/data";

const SCROLL_SETTLE_MS = 300;
const SCROLL_CORRECT_MS = 1600;

export default function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  useSEO({
    title: "Glebe Park Dental | Dentist in Canberra City — Dr Avantica Gupta",
    description: "Friendly, honest dentistry on Coranderrk Street, next to Glebe Park in Canberra City. Check-ups, same-day crowns, implants, whitening, kids' dentistry and more. New patients welcome.",
    path: "/",
  });

  const scrollTarget = location.state?.scrollTo || (location.hash ? location.hash.slice(1) : null);

  useEffect(() => {
    if (!scrollTarget) return undefined;
    const t = setTimeout(() => scrollToId(scrollTarget), SCROLL_SETTLE_MS);
    const t2 = setTimeout(() => {
      scrollToId(scrollTarget, 0.6);
      if (location.state?.scrollTo) navigate(location.pathname, { replace: true, state: {} });
    }, SCROLL_CORRECT_MS);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, [scrollTarget, location.state?.scrollTo, location.pathname, navigate]);

  return (
    <main>
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Services />
      <Offers />
      <Team />
      <Gallery />
      {FEATURES.testimonials && <Testimonials />}
      <HealthFundsMarquee />
      <PreferredProvider />
      <PartnerCompanies />
      <GovernmentAccepted />
      <BlogTeaser />
      <Contact />
      <Footer />
    </main>
  );
}
